export class ContactPointService {
    /* @ngInject */
    constructor($http, egUrlService, $window, $log, $q) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$window = $window;
        this.$log = $log;
        this.$q = $q;
        this.params = {};
        this.requestSuccessCallback = (response) => {
            return this._requestSuccess(response);
        };
        this.requestErrorCallback = (response) => {
            return this._requestError(response);
        };
    }

    requestContactPoints(userId) {
        var url = this.egUrlService.url('/authentication/email');
        return this.$http.get(url, {params: {'userId': userId}})
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }


    requestEmail() {
        var url = this.egUrlService.url('/authentication/email');
        return this.$http.get(url)
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }

    requestVerificationCodeForContactPoint(value) {
        var url = this.egUrlService.url('/authentication/verifications/VERIFY_DEVICETOKEN');
        return this.$http.put(url, value)
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }

    requestVerificationCodeByType(password, username) {
        var url = this.egUrlService.url('/authentication/verifications/VERIFY_DEVICETOKEN');
        return this.$http.put(url, password, {
                params: {
                    'username': username,
                }
            })
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }

    verifyContactPoint(value, verificationCode) {
        var url = this.egUrlService.url('/authentication/verifications/VERIFY_DEVICETOKEN/verify');
        return this.$http.post(url, {'value': value, 'verificationCode': verificationCode})
            .then(this.requestSuccessCallback);
    }

    sendVerificationCodeByType(userDetails, verificationCode) {
        var url = this.egUrlService.url('/authentication/verifications/VERIFY_DEVICETOKEN/verify');
        return this.$http.post(url, {'value': userDetails.deviceTokenUuid, 'verificationCode': verificationCode},
            {params: {'username': userDetails.name}})
            .then(this.requestSuccessCallback, this.requestErrorCallback);
    }

    _requestSuccess(response) {
        return response.data;
    }

    _requestError(response) {
        return this.$q.reject(response);
    }
}
